import { z } from "zod";

import { conditionBuildSchema, effectBuildSchema, triggerConditionBuildSchema } from "../shared/index.ts";

// same shape as condition build for now but not sure if e.g. omit ids
export const conditionDesignSchema = conditionBuildSchema;

export type ConditionDesign = z.infer<typeof conditionDesignSchema>;

export const effectDesignSchema = effectBuildSchema;

// same shape as condition build for now but not sure if e.g. omit ids
export type EffectDesign = z.infer<typeof effectDesignSchema>;

export const responseDesignSchema = z.object({
  id: z.number(), // used at runtime so we need to keep it stable
  label: z.string().optional(),
  condition: conditionDesignSchema.optional(),
  effects: z.array(effectDesignSchema),
});

export type ResponseDesign = z.infer<typeof responseDesignSchema>;

export const triggerCaseDesignSchema = z.object({
  eventType: z.string(),
  where: triggerConditionBuildSchema.optional(),
});

export type TriggerCaseDesign = z.infer<typeof triggerCaseDesignSchema>;

export const handlerCaseDesignSchema = z.object({
  eventType: z.string(),
  where: triggerConditionBuildSchema.optional(),
});

export type HandlerCaseDesign = z.infer<typeof handlerCaseDesignSchema>;

export const handlerDesignSchema = z.object({
  id: z.number(),
  label: z.string().optional(),
  cases: z.array(handlerCaseDesignSchema).optional(),
  responses: z.array(responseDesignSchema),
});

export type HandlerDesign = z.infer<typeof handlerDesignSchema>;

export const triggerDesignSchema = z.object({
  id: z.number(),
  label: z.string().optional(),
  cases: z.array(triggerCaseDesignSchema),
  handlers: z.array(handlerDesignSchema),
});

export type TriggerDesign = z.infer<typeof triggerDesignSchema>;
